var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle, _circle2, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoalOrientatedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M29.4088 18.4638C29.4088 23.812 25.0732 28.1475 19.725 28.1475C14.3768 28.1475 10.0413 23.812 10.0413 18.4638C10.0413 13.1156 14.3768 8.78003 19.725 8.78003C25.0732 8.78003 29.4088 13.1156 29.4088 18.4638Z",
    fill: "#F93749"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0773 30.3495C25.7148 32.0128 22.834 32.9895 19.7251 32.9895C16.29 32.9895 13.1334 31.7971 10.6466 29.8036M29.7296 28.9949C32.5145 26.3485 34.2507 22.6089 34.2507 18.4639C34.2507 15.6157 33.431 12.959 32.0146 10.7169M9.19401 28.4684C6.71855 25.8635 5.19946 22.3411 5.19946 18.4639C5.19946 10.4416 11.7028 3.93823 19.7251 3.93823C23.684 3.93823 27.273 5.52199 29.893 8.09048",
    stroke: "#F93749",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6484 25.0742C11.0312 23.3436 10.0413 21.0193 10.0413 18.4638C10.0413 13.1156 14.3768 8.78003 19.725 8.78003C22.3269 8.78003 24.6892 9.80622 26.4291 11.4759M28.1133 13.6219C28.9372 15.0463 29.4088 16.6999 29.4088 18.4638C29.4088 21.21 28.2656 23.6893 26.4291 25.4516M24.5669 26.852C23.1425 27.676 21.4888 28.1475 19.725 28.1475C17.9612 28.1475 16.3075 27.676 14.8831 26.852",
    stroke: "#F93749",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.92618 33.5043C9.04008 33.3762 9.10299 33.2107 9.10299 33.0392V30.4566C9.10299 30.07 8.78959 29.7566 8.403 29.7566H5.82038C5.63473 29.7566 5.45669 29.8304 5.32541 29.9617L2.00491 33.2822C1.80471 33.4824 1.74482 33.7834 1.85317 34.045C1.96152 34.3066 2.21676 34.4771 2.49989 34.4771H4.47539L4.75848 36.4587C4.79702 36.7286 4.98868 36.9515 5.24968 37.03C5.51068 37.1086 5.79354 37.0285 5.97463 36.8248L8.92618 33.5043Z",
    stroke: "#F93749",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.77201 30.0876L4.71362 34.146",
    stroke: "#F93749",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6843 32.3015C31.6843 31.9149 31.9977 31.6015 32.3843 31.6015H34.9669C35.1525 31.6015 35.3306 31.6752 35.4618 31.8065L38.7823 35.127C38.9825 35.3272 39.0424 35.6283 38.9341 35.8899C38.8257 36.1514 38.5705 36.322 38.2874 36.322H36.3119L36.0288 38.3036C35.9902 38.5734 35.7986 38.7963 35.5376 38.8749C35.2766 38.9534 34.9937 38.8734 34.8126 38.6696L31.8611 35.3491C31.7472 35.221 31.6843 35.0555 31.6843 34.8841V32.3015Z",
    stroke: "#F93749",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3843 32.3013L36.0737 35.9907",
    stroke: "#F93749",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1011 16.3889C24.3999 17.0178 24.5671 17.7213 24.5671 18.4639C24.5671 21.138 22.3993 23.3058 19.7252 23.3058C17.0511 23.3058 14.8833 21.138 14.8833 18.4639C14.8833 15.7899 17.0511 13.6221 19.7252 13.6221C20.9967 13.6221 22.1538 14.1122 23.0177 14.9139",
    stroke: "#F93749",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.725,
    cy: 18.4639,
    r: 1.45256,
    stroke: "#F93749",
    strokeWidth: 1.4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.725,
    cy: 18.4639,
    r: 0.7,
    fill: "#F93749",
    stroke: "#F93749",
    strokeWidth: 0.53675
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7545 4.9033C30.6406 5.03143 30.5777 5.19691 30.5777 5.36835V7.95096C30.5777 8.33756 30.8911 8.65096 31.2777 8.65096H33.8603C34.0459 8.65096 34.224 8.57721 34.3552 8.44594L37.6757 5.12544C37.8759 4.92524 37.9358 4.62416 37.8275 4.36258C37.7191 4.10101 37.4639 3.93046 37.1808 3.93046H35.2053L34.9222 1.94886C34.8836 1.67903 34.692 1.45612 34.431 1.37756C34.17 1.299 33.8871 1.37908 33.706 1.5828L30.7545 4.9033Z",
    stroke: "#F93749",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9087 8.31991L34.9671 3.89258",
    stroke: "#F93749",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoalOrientatedIcon);
export default __webpack_public_path__ + "static/media/goal-orientated-icon.6a478d84b5f0d737467d708a8279b5b5.svg";
export { ForwardRef as ReactComponent };